module.exports = __webpack_public_path__ + "asset/image-Wifi-b229ab6183f1df53.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Wifi.svg
// module id = B2J5
// module chunks = 0